export const DESTINATION_SET_DESTINATION = "destination/set-destination";
